export enum AccountStatus {
  Allowed = 'allowed',
  Blocked = 'blocked',
}

const accountStatusLabels: Record<string, string> = {
  [AccountStatus.Allowed]: 'Active',
  [AccountStatus.Blocked]: 'Blocked',
};

export const formatAccountStatus = (status: string) => {
  if (!status) return '—';
  return accountStatusLabels[status.toLowerCase()] ?? status;
};
